var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoConnection = function SvgNoConnection(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 250 200",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F7FF",
    fillRule: "evenodd",
    d: "M56 127a7 7 0 0 0 7 7h146a7 7 0 1 0 0-14h-6a7 7 0 1 1 0-14h19a7 7 0 1 0 0-14h-22a7 7 0 1 0 0-14h-64a7 7 0 1 0 0-14H79a7 7 0 1 0 0 14H39a7 7 0 1 0 0 14h25a7 7 0 1 1 0 14H24a7 7 0 1 0 0 14h39a7 7 0 0 0-7 7m170 7a7 7 0 1 0 0-14 7 7 0 0 0 0 14",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M92 140c-12.15 0-22-9.626-22-21.5S79.85 97 92 97q.776 0 1.537.052A34 34 0 0 1 93 91c0-18.778 15.222-34 34-34 14.991 0 27.716 9.702 32.239 23.17A31 31 0 0 1 162.5 80c16.845 0 30.5 13.432 30.5 30 0 15.741-12.325 28.727-28 29.978V140h-56.492m-4.512 0h-6.965z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#75A4FE",
    d: "M92 141.25a1.25 1.25 0 0 0 0-2.5zm1.537-44.198-.084 1.247 1.597.108-.283-1.576zm65.702-16.883-1.185.398.318.95.997-.104zm5.761 59.81-.099-1.246-1.151.092v1.154zm0 .022v1.25h1.25V140zm-56.492-1.25a1.25 1.25 0 1 0 0 2.5zm-4.512 2.5a1.25 1.25 0 0 0 0-2.5zm-6.965-2.5a1.25 1.25 0 0 0 0 2.5zm-5.031 0c-11.487 0-20.75-9.093-20.75-20.25h-2.5c0 12.591 10.437 22.75 23.25 22.75zM71.25 118.5c0-11.157 9.263-20.25 20.75-20.25v-2.5c-12.813 0-23.25 10.159-23.25 22.75zM92 98.25q.733 0 1.453.049l.168-2.495A24 24 0 0 0 92 95.75zm2.767-1.42A33 33 0 0 1 94.25 91h-2.5c0 2.14.19 4.236.557 6.273zM94.25 91c0-18.087 14.663-32.75 32.75-32.75v-2.5c-19.468 0-35.25 15.782-35.25 35.25zM127 58.25c14.438 0 26.697 9.344 31.054 22.317l2.37-.795C155.735 65.81 142.544 55.75 127 55.75zm32.369 23.163a30 30 0 0 1 3.131-.163v-2.5q-1.719.001-3.391.176zm3.131-.163c16.174 0 29.25 12.891 29.25 28.75h2.5c0-17.278-14.235-31.25-31.75-31.25zM191.75 110c0 15.07-11.805 27.532-26.849 28.732l.198 2.492c16.307-1.301 29.151-14.813 29.151-31.224zm-28 29.978V140h2.5v-.022zm1.25-1.228h-56.492v2.5H165zm-61.004 0h-6.965v2.5h6.965z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#A4C3FE",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    rx: 6.72,
    ry: 6.647,
    transform: "matrix(-1 0 0 1 143.72 75.647)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115,
    cy: 104.5,
    stroke: "#75A4FE",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    rx: 7,
    ry: 3.5,
    transform: "rotate(-180 115 104.5)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 144,
    cy: 104.5,
    stroke: "#75A4FE",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    rx: 7,
    ry: 3.5,
    transform: "rotate(-180 144 104.5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#75A4FE",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M122 120h14.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#75A4FE",
    fillRule: "evenodd",
    d: "M69.156 60.292H57.21v2.376h8.448l-9.152 11.088V76h12.87v-2.376h-9.372l9.152-11.242zm13.412 15.284H73.88v1.728h6.144l-6.656 8.064V87h9.36v-1.728h-6.816l6.656-8.176z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoConnection);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/no_connection.77afb0937fb2cd201c67740888d7d552.svg";